module.exports = __webpack_public_path__ + "static/assets/783d87a11d87b2c498242905634a62e4.png";